import { format, toZonedTime } from 'date-fns-tz';
import qs from 'qs';

const now = new Date().toISOString();
const weekday = format(toZonedTime(new Date(), 'UTC'), 'EEEE');

export const getCMSSchedulerQuery = () => {
  return {
    $or: [
      {
        scheduler: {
          id: {
            $null: true,
          },
        },
      },
      {
        scheduler: {
          weekday: {
            $eq: weekday,
          },
        },
      },
    ],
  };
};

export const getCMSDurationQuery = () => {
  return {
    $or: [
      {
        duration_from: { $null: true },
        duration_to: { $null: true },
      },
      {
        duration_from: { $lt: now },
        duration_to: { $null: true },
      },
      {
        duration_from: { $null: true },
        duration_to: { $gt: now },
      },
      {
        duration_from: { $lt: now },
        duration_to: { $gt: now },
      },
    ],
  };
};

export const getCMSCountryQuery = (countryCode: string) => {
  return [
    {
      $or: [
        { country_codes_exclude: { $null: true } },
        { country_codes_exclude: { $eq: '' } },
        { country_codes_exclude: { $not: { $contains: countryCode } } },
      ],
    },
    {
      $or: [
        { country_codes_include: { $null: true } },
        { country_codes_include: { $eq: '' } },
        { country_codes_include: { $contains: countryCode } },
      ],
    },
  ];
};

export const getCMSShowGuestQuery = (isAuthenticated: boolean) => {
  return isAuthenticated ? [] : [{ show_guest_toggle: { $eq: true } }];
};

export const getCMSImageFieldsUrl = (name: string) => {
  return {
    [name]: {
      fields: ['url'],
    },
  };
};

export enum CMSSortTypeEnum {
  ASC = 'asc',
  DESC = 'desc',
}

interface ICMSQuery {
  sort?: string[];
  filters?: Record<string, any>;
  populate?: Record<string, any>;
  locale?: string[];
  pagination?: {
    pageSize: number;
  };
}

export const createCMSQuery = (data: ICMSQuery) =>
  qs.stringify(data, { encodeValuesOnly: true });
